<template>
  <div
    class="w-full sm:w-auto flex flex-row sm:flex-col items-start justify-between"
  >
    <h4
      class="flex items-center relative font-interDisplay text-xs text-gray-380 font-semibold leading-130"
    >
      <span class="w-2 h-2 rounded-sm rotate-45 mr-1" :class="iconStyle" />
      <span>{{ title }}</span>
    </h4>
    <div class="flex flex-wrap gap-1 items-center">
      <h2
        class="font-interDisplay text-base text-dark font-semibold leading-130"
      >
        {{ formatMoneyDecimal(profit, 2).split(".")?.[0]
        }}<span class="text-gray-380" v-if="profit"
          >.{{ formatMoneyDecimal(profit, 2).split(".")?.[1] }}
        </span>
        <span class="ml-1 text-xs"> USDT </span>
      </h2>
      <div class="w-1 h-1 bg-gray-380 rounded-full mx-1" v-if="percentage" />
      <ProfitLostInfo
        without-icon
        :class="infoClass"
        :profit="profit"
        :percentage="percentage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatMoneyDecimal } from "@/utils";
import ProfitLostInfo from "@/components/Common/ProfitLostInfo.vue";
import { TClassName } from "@/types/common";

interface Props {
  title: string;
  profit: string;
  percentage?: number;
  infoClass?: TClassName;
  iconStyle?: TClassName;
}
defineProps<Props>();
</script>
